export class User {
  auth0UserId?: string;

  /** Might not be the user's name, better to use givenName and familyName */
  name?: string;
  givenName?: string;
  familyName?: string;
  nickname?: string;

  email?: string;

  ssUid?: string;

  picture?: string;

  updatedAt?: string;
  [key: string]: string | boolean | undefined;

  constructor (auth0User: { [key: string]: string | boolean | undefined }) {
    if (!auth0User) {
      return;
    }

    this.auth0UserId = auth0User.sub as string;
    this.name = auth0User.name as string;
    this.givenName = auth0User.given_name as string;
    this.familyName = auth0User.family_name as string;
    this.nickname = auth0User.nickname as string;
    this.email = auth0User.email as string;
    this.ssUid = auth0User['http://simplisafe.com/uid'] as string;
    this.picture = auth0User.picture as string;
    this.updatedAt = auth0User.updated_at as string;
  }
}
